import React, { memo } from 'react';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import { increase_months_list } from '../Const';
import Paragraph from '../molecules/Paragraph';

interface Props {
  fm_id: number;
  label: string;
  need?: boolean;
  disabled: boolean;
  help_msg?: string;
  message?: string;
  value: string[] | null;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  looks_inactive: boolean;
  readonly?: boolean;
}

// 特定月増額返済(増額月)の選択
const IncreaseMonthsSelect: React.FC<Props> = ({
  fm_id,
  label,
  need,
  disabled,
  help_msg,
  message,
  value,
  handleChange,
  looks_inactive,
  readonly,
}) => {
  /**
   * チェックボックスを動的に活性・非活性状態を切り替える
   * NOTE チェックボックスを非活性にする条件
   * 1. 月を選択している個数が2つであること
   * 2. 選択されていない月であること
   * @param string month 月(1, 2, 3 ... 12)
   * @returns boolean
   */
  const setDisabled = (month: string) => {
    return value !== null && value.length === 2 && !value.includes(month);
  };

  /**
   * 初期の選択状態を設定する
   * @param string month 月(1, 2, 3 ... 12)
   * @returns boolean
   */
  const setDefaultSelected = (month: string) => {
    // valueがnullやundefinedでない場合、かつ配列である場合はincludesした結果を返却する
    if (value !== null && typeof value !== 'undefined' && typeof value === 'object') {
      return value.includes(month);
    }
    return false;
  };

  /**
   * チェックボックスのJSXElementを返却して表示する
   * @param string month 月(1, 2, 3 ... 12)
   * @param string name 月の表示名(1月, 2月, 3月 ... 12月)
   * @returns JSXElement
   */
  const createCheckbox = (month: string, name: string) => {
    return (
      <p key={`month-${month}`}>
        <label className="check-box-label c-check-label">
          <input
            type="checkbox"
            className="input-checkbox"
            value={month}
            defaultChecked={setDefaultSelected(month)}
            onChange={handleChange}
            disabled={setDisabled(month) || readonly}
            data-fm_id={fm_id}
          />
          <span className="check-icon" />
          <span className="check-txt">{name}</span>
        </label>
      </p>
    );
  };

  /**
   * 非活性表示時の value 指定
   */
  const setValue = (value: string) => {
    return increase_months_list.find(month => month.value === value)?.name ?? '';
  };

  /**
   * disabled表示のvalueを作成する
   * @return ラベル
   */
  const returnLabel = () => {
    if (value) {
      return value.length === 0
        ? ''
        : value.length === 1
        ? setValue(value[0])
        : value.length === 2
        ? `${setValue(value[0])} ${setValue(value[1])}`
        : '';
    } else {
      return '';
    }
  };

  return (
    <RowTemplate
      label={label}
      need={need}
      disabled={disabled}
      looks_inactive={looks_inactive}
      content={
        disabled || looks_inactive ? (
          <Paragraph label={returnLabel()} />
        ) : (
          <div id="increase-months-select">
            {increase_months_list.map(month => {
              return createCheckbox(month.value, month.name);
            })}
            <Messages help_msg={help_msg} valid_msg={message} />
          </div>
        )
      }
    />
  );
};

export default memo(IncreaseMonthsSelect);
